import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { agendarProfile, noProfile } from "../../profiles/profiles";
import { UserJWTCredentials } from "../../types/authTypes";
import { AvailableMenuItems } from "../../types/profileTypes";

const initialState: UserJWTCredentials & AvailableMenuItems = {
  user: {
    TIPO: "",
  },
  exp: NaN,
  iat: NaN,
  availableitems: {
    agendar: false,
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<UserJWTCredentials>) => {
      switch (parseInt(action.payload.user.TIPO)) {
        case 1:
          return { ...action.payload, ...agendarProfile };
          break;

        default:
          return { ...action.payload, ...noProfile };
          break;
      }
    },
    clearUserState: (state) => {
      return initialState;
    },
  },
});

export const { setCredentials } = userSlice.actions;
